import React from "react"
import { useFormContext } from "react-hook-form"
import { CheckboxField } from "../fields/CheckboxField"

type Props = {
  label?: string
  name: string
  value?: any
  checkboxText?: string
  labelLink?: React.ReactNode
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  wrapperWidth?: string
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >

export const CheckboxInput = ({
  label,
  name,
  value,
  labelLink,
  onChange,
  checkboxText,
  wrapperWidth,
  ...rest
}: Props) => {
  const { register } = useFormContext()
  const {
    ref: hookref,
    onChange: hookOnChange,
    ...hookFormProps
  } = register(name as string)

  const customOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e)
    }
    hookOnChange(e)
  }

  return (
    <CheckboxField
      label={label}
      value={value}
      innerText={checkboxText}
      innerRef={hookref}
      labelLink={labelLink}
      wrapperWidth={wrapperWidth}
      onChange={customOnChange}
      {...hookFormProps}
      {...rest}
    />
  )
}
